import Service from '../../../ajax/Service';

const relativeUrl = 'api/session/promo';

class PromoCode {
  post(data) {
    const service = new Service();
    return service.post(relativeUrl, data);
  }

  get() {
    const service = new Service();
    return service.get(relativeUrl);
  }

  delete() {
    const service = new Service();
    return service.delete(relativeUrl);
  }
}

export default PromoCode;



// WEBPACK FOOTER //
// ./src/tnew/lib/api/tnew/system/PromoCode.js